const scrollTop = () => {
  document.querySelector('html').scrollTop = 0;
};

export { scrollTop };
